{
  "About Page": "About Page",
  "Add Google, Facebook, or Custom Link": "Add Google, Facebook, or Custom Link",
  "Add Link": "Add Link",
  "Add Logo": "Add Logo",
  "Add Social Platform": "Add Social Platform",
  "Add various links": "Add various links",
  "Address Line 1": "Address Line 1",
  "Address Line 2": "Address Line 2",
  "Appointment URL": "Appointment URL",
  "Appointment link": "Appointment link",
  "Appointment link is an external website link for patients to book appointments. Please ensure the link URL has correct metadata eg: Location identifiers, payment details, redirects, etc.": "Appointment link is an external website link for patients to book appointments. Please ensure the link URL has correct metadata eg: Location identifiers, payment details, redirects, etc.",
  "Are You Sure?": "Are You Sure?",
  "Beta": "Beta",
  "Blog": "Blog",
  "Brand Details": "Brand Details",
  "Brand Details Manage All": "Brand Details Manage All",
  "Canada": "Canada",
  "Changes will override current settings.": "Changes will override current settings.",
  "City": "City",
  "Connect Social Platforms": "Connect Social Platforms",
  "Contact Page": "Contact Page",
  "Country": "Country",
  "Custom": "Custom",
  "Custom Link": "Custom Link",
  "Delete": "Delete",
  "Delete Link": "Delete Link",
  "Delete Logo": "Delete Logo",
  "Delete Platform": "Delete Platform",
  "Deleting logo will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting logo will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Deleting this link will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting this link will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Deleting this social platform will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting this social platform will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Edit in Email Settings": "Edit in Email Settings",
  "Email Address": "Email Address",
  "Enter Platform Name ...": "Enter Platform Name ...",
  "Enter URL ...": "Enter URL ...",
  "External Name": "External Name",
  "FAQ": "FAQ",
  "Facebook": "Facebook",
  "Failed to delete logo. Please try again.": "Failed to delete logo. Please try again.",
  "Google": "Google",
  "Help Center": "Help Center",
  "Implement your brand and create a customized experience across Weave.": "Implement your brand and create a customized experience across Weave.",
  "Internal Name": "Internal Name",
  "Links": "Links",
  "Location Address": "Location Address",
  "Location Contact Information": "Location Contact Information",
  "Location Name": "Location Name",
  "Locations": "Locations",
  "Logo": "Logo",
  "Logo Preview": "Logo Preview",
  "Logo deleted successfully!": "Logo deleted successfully!",
  "Logo upload failed. Please try again.": "Logo upload failed. Please try again.",
  "Logo uploaded successfully!": "Logo uploaded successfully!",
  "Map": "Map",
  "No phone numbers available": "No phone numbers available",
  "Note: Edit the Appointment link in the 'Links' section below. The Appointment link will be moved entirely to the 'Links' section soon. ": "Note: Edit the Appointment link in the 'Links' section below. The Appointment link will be moved entirely to the 'Links' section soon. ",
  "Other": "Other",
  "Payment Link": "Payment Link",
  "Phone Number": "Phone Number",
  "Platform Name": "Platform Name",
  "Please enter a URL.": "Please enter a URL.",
  "Please enter a complete website address (e.g., https://example.com).": "Please enter a complete website address (e.g., https://example.com).",
  "Please enter a https URL. For example, https://demo.com": "Please enter a https URL. For example, https://demo.com",
  "Please enter a valid URL.": "Please enter a valid URL.",
  "Please enter a valid website address. For example, demo.com or www.demo.com or https://demo.com or https://www.demo.com": "Please enter a valid website address. For example, demo.com or www.demo.com or https://demo.com or https://www.demo.com",
  "Please enter a valid website address: for example, demo.com or www.demo.com or http://demo.com or http://www.demo.com or https://demo.com or https://www.demo.com": "Please enter a valid website address: for example, demo.com or www.demo.com or http://demo.com or http://www.demo.com or https://demo.com or https://www.demo.com",
  "Please enter the Appointment URL link.": "Please enter the Appointment URL link.",
  "Postal Code": "Postal Code",
  "Promotional Page": "Promotional Page",
  "Referral Page": "Referral Page",
  "Select New Image": "Select New Image",
  "Select type": "Select type",
  "Shop": "Shop",
  "State": "State",
  "The selected image has no URL. Please select a different image.": "The selected image has no URL. Please select a different image.",
  "There was an issue with the file you uploaded. Please try again with a different file.": "There was an issue with the file you uploaded. Please try again with a different file.",
  "This is the name used within Weave to identify this location. To change it, please contact Weave Support.": "This is the name used within Weave to identify this location. To change it, please contact Weave Support.",
  "This is the public-facing address that will represent this location.": "This is the public-facing address that will represent this location.",
  "This is the public-facing business name your customers will see in message templates and emails.": "This is the public-facing business name your customers will see in message templates and emails.",
  "This is the public-facing contact information that will represent this location in cases where phone numbers and emails are pre-filled.": "This is the public-facing contact information that will represent this location in cases where phone numbers and emails are pre-filled.",
  "Type": "Type",
  "URL": "URL",
  "URL must start with http:// or https://": "URL must start with http:// or https://",
  "USA": "USA",
  "Unspecified": "Unspecified",
  "Web Page": "Web Page",
  "You cannot manage all for Facebook or Google settings due to authorization restrictions.": "You cannot manage all for Facebook or Google settings due to authorization restrictions.",
  "You cannot manage all for this particular setting.": "You cannot manage all for this particular setting.",
  "Your Brands": "Your Brands"
}
